// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"600":"def42faab78debbbd93b","788":"def42faab78debbbd93b"}[chunkId] + ".chunk.css";
};